module.exports = __webpack_public_path__ + "img/access_denied.51c581fc.svg";